<span class="section-date-details">
  <span class="dates-range-display-message">
    <!-- dates displayed -->
    <!-- && (item.hierarchy=='OWNER' || item.hierarchy=='COLLABORATOR') -->
    <span
      *ngIf="showOnlyInRange"
      class="only-dates dates-range"
      [ngClass]="{ 'not-displayed': !isInDateRange, displayed: isInDateRange }"
      [tooltip]="'section.publishSectionVisible' | translate"
      attr.aria-label="'section.publishSectionVisible'| translate}}">
      <i *ngIf="isInDateRange" class="fa fa-calendar-check-o" attr.aria-hidden="true"></i>
      <i *ngIf="!isInDateRange" class="fa fa-calendar-times-o" attr.aria-hidden="true"></i>
      <span> {{ start | customerDate }} - {{ end | customerDate }} </span>
    </span>
    <!-- dates always displayed  -->
    <span class="dates-range" *ngIf="!showOnlyInRange">
      <span class="dates only-dates"> {{ start | customerDate }} - {{ end | customerDate }}</span>
    </span>
  </span>
</span>
